/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Map_SampleInputs */

const cs_import_map_sample = /** @type {(inputs: Import_Map_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukázka`)
};

const en_import_map_sample = /** @type {(inputs: Import_Map_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample`)
};

/**
* | output |
* | --- |
* | "Sample" |
*
* @param {Import_Map_SampleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_map_sample = /** @type {((inputs?: Import_Map_SampleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Map_SampleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_map_sample(inputs)
	return cs_import_map_sample(inputs)
});